module.exports = __webpack_public_path__ + "static/media/m-all.f59200f8.svg";